import React from 'react'
import { connect } from 'react-redux'
import Toggle from 'react-toggle'
import Modal from 'react-responsive-modal'
import UpdatePromoSection from '../../Containers/Promo/UpdatePromoSection'
import PromoSectionActions from '../../Redux/PromoSectionRedux'

class PromoSectionPage extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      showModal: '',
      detail: {}
    }
  }

  componentDidMount () {
    this.props.getPromoSection()
  }

  componentDidUpdate (prevProps, prevState) {
    if (prevProps.promoSection.processing !== this.props.promoSection.processing && this.props.promoSection.processing === false) {
      this.props.getPromoSection()
    }
  }

  _toggleStatus = (value) => {
    let data = { ...this.props.promoSection.data }
    let form = {
      title: data.title,
      status: data.status,
      url: data.url,
      image_file: data.image_file
    }

    if (value === 'active') {
      form.status = 'inactive'
    } else {
      form.status = 'active'
    }

    console.log(form.status)

    this.props.updatePromoSection({ id: data.id, form })
  } 

  _toggleModal = (modalId = null) => {
    if (!modalId) this.props.getPromoSection()
    this.setState({
      showModal: modalId
    })
  }

  render () {
    const { promoSection } = this.props
    return (
      <div>
        <header className='section'>
          <div className='title-block'>
            <h3 className='title'>
              Section Promo
              {
                (promoSection.fetching || promoSection.processing) &&
                <div className='badge badge-info ml-2'>{promoSection.fetching ? 'Loading' : 'Processing'} ...</div>
              }
            </h3>
          </div>
        </header>
        <div className='section'>
          <div className='card card-block'>
            {
              !(promoSection.fetching || promoSection.processing) && promoSection.err &&
              <div className='alert alert-danger'>{promoSection.err}</div>
            }
            <div className='row'>
              <div className='col-4'>
                <img src={promoSection.data.image_url} className='img-fluid rounded' alt={promoSection.data.title} />
              </div>
              <div className='col-8'>
                <div className='d-block mb-3'>
                  <b>Title:</b>
                  <br />
                  <span>{promoSection.data.title}</span>
                </div>
                <div className='d-block mb-3'>
                  <b>Subtitle:</b>
                  <br />
                  <span>{promoSection.data.subtitle}</span>
                </div>
                <div className='d-block mb-3'>
                  <b>Content:</b>
                  <div style={{ whiteSpace: 'pre' }}>
                    {promoSection.data.content}
                  </div>
                </div>
                <div className='d-block mb-3'>
                  <b>CTA:</b>
                  <br />
                  <a href={promoSection.data.url}>{promoSection.data.url}</a>
                </div>
                <div className='d-block mb-2'>
                  <b>Active :</b>
                  <br />
                  <Toggle disabled={promoSection.processing || promoSection.fetching} checked={promoSection.data.status === 'active'} onChange={() => this._toggleStatus(promoSection.data.status)} />
                </div>
              </div>
              <div className='col-12 text-right'>
                <button className='btn btn-primary btn-lg' onClick={() => this._toggleModal('change-promo')}>Edit</button>
              </div>
            </div>
          </div>
        </div>
        <Modal className={{ modal: 'modal-large' }} open={this.state.showModal === 'change-promo'} onClose={this._toggleModal}>
          <UpdatePromoSection detail={promoSection.data} closeModal={() => this._toggleModal()} />
        </Modal>
      </div>
    )
  }
}

const stateToProps = (state) => ({
  promoSection: state.promoSection
})

const dispatchToProps = (dispatch) => ({
  getPromoSection: () => dispatch(PromoSectionActions.getPromoSectionRequest()),
  updatePromoSection: (data) => dispatch(PromoSectionActions.updatePromoSectionRequest(data))
})

export default connect(stateToProps, dispatchToProps)(PromoSectionPage)



// WEBPACK FOOTER //
// ./src/Pages/Misc/PromoSectionPage.js